// ********* Import CSS ******************** //

import "./flyer-popup.css";


// **************** Modal ******************** //

class FlyerPopup extends HTMLElement {
  connectedCallback() {

    this.innerHTML = `

      <div id="flyer-popup" class="modal">

        <span id="close-modal" class="close">&times;</span>

        <img class="flyer-modal-content" id="img01" width="100px">

      </div>
    `
  }
}

customElements.define('flyer-popup', FlyerPopup);


// ********************** Flyer Popup Modal *********************** //

var flyerPopup = document.getElementById('flyer-popup');

const flyerButtonSm = document.getElementById("flyerButtonSm");

const flyerButtonLg = document.getElementById("flyerButtonLg");

var flyerImgSm = document.getElementById("flyerImgSm");

var flyerImgLg = document.getElementById("flyerImgLg");

var modalImg = document.getElementById("img01");


// ************** BEGIN: Close Flyer Popup Modal ******************//

var flyerModalClose = document.getElementById('close-modal');

flyerModalClose.addEventListener('click', event => {
  flyerPopup.style.display = "none";
});

// *************** END: Close Flyer Popup Modal ******************//


// ************** BEGIN: Open Flyer Popup Modal ******************//

if (flyerButtonSm) {
  flyerButtonSm.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Button Clicked");

    var imgSrc = flyerImgSm.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}

if (flyerButtonLg) {
  flyerButtonLg.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Button Clicked");

    var imgSrc = flyerImgLg.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}


